import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { ContextSelectorLinkComponent } from 'account-hybrid/features/context-selector/components/context-selector-link/context-selector-link.component';
import { CONTEXT_SELECTOR_FEATURE_NAME, contextSelectorReducer } from 'account-hybrid/features/context-selector/store';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { Ng2SearchPipeModule } from 'apps/account/src/app/common/modules/ng2-search-filter/ng2-search-filter';
import { ContextSelectorComponent } from './components/contex-selector/context-selector.component';

@NgModule({
    declarations: [ContextSelectorComponent, ContextSelectorLinkComponent],
    exports: [
        ContextSelectorLinkComponent,
        ContextSelectorComponent
    ],
    imports: [
        CommonModule,
        AccountSharedModule,
        StoreModule.forFeature(CONTEXT_SELECTOR_FEATURE_NAME, contextSelectorReducer),
        FormsModule,
        Ng2SearchPipeModule
    ]
})
export class ContextSelectorModule {
}
